import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PigeonholeService } from 'src/app/core/data-sources/v3/pigeonhole/pigeonhole.service';
import { CratesDataSourceService } from 'src/app/core/data-sources/crates-data-source.service';
import { columnToNumber } from '../../helpers/format-position';

export interface PigeonholeRowColumnModalData {
  type: 'row' | 'column';
  coordinate: string;
  id: string;
  selectedTabIndex?: number;
  scrollTo?: string | null;
}

@Component({
  selector: 'app-pigeonhole-row-column-modal',
  templateUrl: './pigeonhole-row-column-modal.component.html',
  styleUrls: ['./pigeonhole-row-column-modal.component.scss']
})
export class PigeonholeRowColumnModalComponent implements OnInit {

  packages = [];
  occupationList = [];
  rowCoords = '';
  columnCoords = '';
  title = '';
  showPalletDetails = false;
  showPositionDetails = true;
  pigeonholes = [];
  palletDetails: any;
  pallet: any;

  constructor(
    private pigeonholeService: PigeonholeService,
    private crateService: CratesDataSourceService,
    public dialogRef: MatDialogRef<PigeonholeRowColumnModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PigeonholeRowColumnModalData,
  ) { }

  ngOnInit(): void {
    this.loadRowOrColumnData(this.data.type);
    this.updateTitle();
  }

  async getOccupationInfo(value: number) {
    const occupationInfo = await this.pigeonholeService.getPigeonholeRowColumnOccupationInfo(
      this.data.id, this.data.type, value
    );
    this.occupationList = [
      { id: 'occupied', name: 'Posições ocupadas', value: occupationInfo.totalOccupiedPigeonholes },
      { id: 'free', name: 'Posições livres', value: occupationInfo.totalFreePigeonholes },
      { id: 'total', name: 'Total de posições', value: occupationInfo.totalPigeonholes }
    ];
  }

  loadRowOrColumnData(type: 'row' | 'column') {
    if (type === 'row') {
      const rowValue = Number(this.data.coordinate) - 1;
      this.rowCoords = `Linha: ${this.data.coordinate}`;
      this.fetchRowOrColumnData(rowValue);
      this.getOccupationInfo(rowValue);
    } else {
      const columnValue = columnToNumber(this.data.coordinate);
      this.columnCoords = `Coluna: ${this.data.coordinate}`;
      this.fetchRowOrColumnData(columnValue);
      this.getOccupationInfo(columnValue);
    }
    this.updateTitle();
  }

  async fetchRowOrColumnData(value: number) {
    const pigeonholeList = await this.pigeonholeService.getPigeonholeRowOrColumnData(this.data.id, this.data.type, value);
    this.packages = this.setRowOrColumnsProperties(pigeonholeList, 'packages');
    this.pigeonholes = this.setRowOrColumnsProperties(pigeonholeList, 'pigeonhole');
  }

  setRowOrColumnsProperties(arr, propertyName: 'packages' | 'pigeonhole') {
    return arr.reduce((acc, obj) => {
      return acc.concat(obj[propertyName]);
    }, []);
  }

  close() {
    this.dialogRef.close();
  }

  openPalletDetails(e): void {
    this.crateService.getCrateById(e.id).then((r: any) => {
      const itemDetails = r;
      this.palletDetails = {
        item: e,
        itemDetails: itemDetails,
        isExit: false
      };
      this.pallet = e;
      this.showPalletDetails = true;
      this.showPositionDetails = false;
      this.updateTitle();
    });
  }

  goBackToMap() {
    if (this.showPalletDetails) {
      this.showPositionDetails = true;
      this.showPalletDetails = false;
      this.data.selectedTabIndex = 1;
      this.data.scrollTo = this.pallet?.tagRfid ?? null;
      this.updateTitle();
    }
  }

  updateTitle() {
    if (this.showPalletDetails) {
      this.title = `Dados Do Pallet`;
      return;
    }
    this.title = this.rowCoords ? this.rowCoords : this.columnCoords;
  }

}
